import _ from "lodash";

export const sortWhiteList = {
  activity: "updated_at",
  additional_information: "additional_information",
  amount: "amount",
  budget_amount: "budget_rate_value",
  company_name: "company_name",
  created_at: "created_at",
  date_approved: "date_approved",
  date_signed_up: "date_signed_up",
  date_submitted: "date_submitted",
  email: "email",
  first_name: "first_name",
  hiring_manager: "first_name",
  last_activity: "last_activity_at",
  last_login_date: "last_login_at",
  last_name: "last_name",
  level: "level",
  metro_area: "metro_area",
  mh: "mh",
  nth: "nth",
  rate_type: "budget_rate_type_id",
  projects_hired: "projects_hired",
  projects_matched: "projects_matched",
  projects_pitched: "projects_pitched",
  projects_posted: "projects_posted",
  projects_sow: "projects_sow",
  referral_type: "referral_type",
  referral_value: "referral_value",
  sort_amount: "amount",
  sort_email: "email",
  sort_filename: "filename",
  sort_first_name: "first_name",
  sort_last_name: "last_name",
  sort_member_name: "member_name",
  sort_metro_area: "metro_area",
  sort_notification_date: "notification_date",
  sort_project_title: "project_title",
  sort_status: "status",
  status: "status_id",
  title: "title"
};

export default sortData => {
  const sortName = _.get(sortData, "[0].id");
  const desc = _.get(sortData, "[0].desc");

  let sortQuery = "";

  if (sortWhiteList[sortName]) {
    const descChar = desc ? "-" : "";

    if (
      sortName === "company_name" ||
      sortName === "date_approved" ||
      sortName === "date_signed_up" ||
      sortName === "date_submitted" ||
      sortName === "projects_hired" ||
      sortName === "projects_matched" ||
      sortName === "projects_pitched" ||
      sortName === "projects_posted" ||
      sortName === "projects_sow" ||
      sortName === "level" ||
      sortName === "metro_area" ||
      sortName === "referral_type" ||
      sortName === "referral_value" ||
      sortName === "sort_amount" ||
      sortName === "sort_email" ||
      sortName === "sort_filename" ||
      sortName === "sort_first_name" ||
      sortName === "sort_last_name" ||
      sortName === "sort_metro_area" ||
      sortName === "sort_member_name" ||
      sortName === "sort_notification_date" ||
      sortName === "sort_project_title" ||
      sortName === "sort_status"
    ) {
      sortQuery = `&filter[sort_${sortWhiteList[sortName]}]=${descChar}${
        sortWhiteList[sortName]
      }`;
    } else {
      sortQuery = `&sort=${descChar}${sortWhiteList[sortName]}`;
    }
  }

  return sortQuery;
};



// WEBPACK FOOTER //
// ./src/utils/parseSortData.js